import { SvgIcon, SvgIconProps } from '@mui/material'

const ReEngageColoredIcon = ({ fill = '#122937', ...props }: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="17"
        height="19"
        viewBox="0 0 17 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.4286 3.37396C11.6458 3.37396 13.6074 4.46832 14.803 6.15055C15.1041 6.57424 15.6917 6.67361 16.1154 6.3725C16.5391 6.07138 16.6384 5.4838 16.3373 5.06011C14.8039 2.90241 12.281 1.49161 9.4286 1.49161C4.75042 1.49161 0.958008 5.28402 0.958008 9.9622C0.958008 10.482 1.37939 10.9034 1.89918 10.9034C2.41898 10.9034 2.84036 10.482 2.84036 9.9622C2.84036 6.32361 5.79001 3.37396 9.4286 3.37396Z"
          fill={fill}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.6827 6.863C16.8592 6.6865 16.9584 6.4471 16.9584 6.19749V1.49161C16.9584 0.971809 16.537 0.55043 16.0172 0.55043C15.4974 0.55043 15.076 0.971809 15.076 1.49161V5.25631H11.3113C10.7915 5.25631 10.3701 5.67769 10.3701 6.19749C10.3701 6.71729 10.7915 7.13866 11.3113 7.13866L16.0172 7.13866C16.2668 7.13866 16.5062 7.03951 16.6827 6.863Z"
          fill="#89949B"
        />
        <path
          d="M8.95304 8.60219C9.10272 8.14153 9.75442 8.14153 9.9041 8.60219L10.6097 10.7739C10.6767 10.98 10.8687 11.1194 11.0853 11.1194L13.3688 11.1194C13.8532 11.1194 14.0545 11.7392 13.6627 12.0239L11.8153 13.3662C11.64 13.4935 11.5667 13.7192 11.6336 13.9252L12.3393 16.0969C12.489 16.5576 11.9617 16.9407 11.5699 16.656L9.72246 15.3137C9.54722 15.1864 9.30992 15.1864 9.13468 15.3137L7.28727 16.656C6.89542 16.9407 6.36817 16.5576 6.51785 16.0969L7.2235 13.9252C7.29043 13.7192 7.21711 13.4935 7.04186 13.3662L5.19446 12.0239C4.8026 11.7392 5.00399 11.1194 5.48835 11.1194L7.77187 11.1194C7.98848 11.1194 8.18046 10.98 8.2474 10.7739L8.95304 8.60219Z"
          fill={fill}
        />
      </svg>
    </SvgIcon>
  )
}

export default ReEngageColoredIcon
